// extracted by mini-css-extract-plugin
export var layoutContainer = "_3l-0";
export var layoutContainerOpen = "_3l-3";
export var mainContent = "_3l-1";
export var panelLarge = "_3l-6";
export var panelMedium = "_3l-5";
export var panelSmall = "_3l-4";
export var slidePanel = "_3l-2";